import React, { Component } from "react";
import { createRoot } from "react-dom/client";
// import { hot } from "react-hot-loader/root";
// import { Provider } from "mobx-react";

import "./assets/css/reset.scss";
import "./index.scss";
import Bottombar from "./components/bottombar";
import Navmenu from "./components/navmenu";
import Topbar from "./components/topbar";
import Router from "./router";

// @hot
class App extends Component {
	render() {
		return (
			// <Provider {...Store}>
				<div className="index-page">
					<Topbar />
					<div className="content center">
						<Navmenu />
						<Router />
					</div>
					<Bottombar />
				</div>
		);
	}
}

console.log("项目构建环境：", process.env.NODE_ENV);
console.log("项目运行环境：", RUN_ENV); // eslint-disable-line
const container = document.getElementById("root");
!!container && createRoot(container).render(<App />);